export default class Notification
{
    static create(user)
    {
        return user.role === 'admin';
    }

    static update(user)
    {
        return user.role === 'admin' || user.role === 'moderator';
    }

    static delete(user)
    {
        return user.role === 'admin';
    }
}
